module.exports = __webpack_public_path__ + "static/media/848NorthAvenueNW_2018-07-09_205.4f1b8b0c.jpg";